var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUpreact = function SvgArrowUpreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.999V11.981A13.7 13.7 0 0 0 11.849-.001S12.638 9.328 24 12.287v11.712s-11.489-1.325-11.933-12.067c-.001 0 .772 10.138-12.067 12.067Z"
  })));
};

export default SvgArrowUpreact;